import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../../hooks'
import { getItemsFromIdwellApiResponse } from '../../../../../../utils/api'
import { getQaSelector } from '../../../../../../utils/common'
import { FormFieldSelectNG } from '../../../../../Form'
import {
  FormikField,
  getFormikFormFieldErrorProps,
} from '../../../../../Formik'
import { getMockApplicantListings } from '../../../../../RentalPortalApplicant'
import { InputAsyncSelect, InputSelectControl } from '../../../../../Select'
import {
  APPLICANT_FORM_FIELD_NAME_LISTING,
  QA_NAME_APPLICANT_FORM_NO_LISTINGS,
} from '../../RentalPortalApplicantForm.constants'
import { getToApplicantListingSelectItems } from '../../RentalPortalApplicantForm.utils'

import RentalPortalIcon from '../../../../../../icons/rental-portal.svg'

function ListingField({ fieldRef }) {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen()

  return (
    <FormikField
      Component={FormFieldSelectNG}
      Control={InputSelectControl}
      EntityIcon={RentalPortalIcon}
      Select={InputAsyncSelect}
      controlProps={{
        borderless: !isMobileScreenSize,
        contentProps: {
          inputProps: {
            placeholder: t('RentalPortal.ApplicantFormListingPlaceholderKey'),
          },
        },
        inputRef: fieldRef,
      }}
      emptyValue={null}
      fieldComponentProps={{
        label: `${t('RentalPortal.ApplicantListingColumnKey')}:`,
        required: true,
        shouldAdaptToMobileScreen: true,
      }}
      getData={getMockApplicantListings}
      getDataItems={getItemsFromIdwellApiResponse}
      getErrorProps={getFormikFormFieldErrorProps}
      listProps={{
        emptyProps: {
          ...getQaSelector({ value: QA_NAME_APPLICANT_FORM_NO_LISTINGS }),
          text: t('RentalPortal.ApplicantFormNoListingsKey'),
        },
      }}
      name={APPLICANT_FORM_FIELD_NAME_LISTING}
      toPreparedItems={getToApplicantListingSelectItems(t)}
    />
  )
}

export default ListingField
